import React, { useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Card, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import CLabel from '../../../../components/Common/CLabel';
import DatePicker from 'react-datepicker';
import { getGridLocalization, isNullUndefinedOrEmpty } from '../../../../common/Helpers';
import { __OBJECT_STRUCTURE_GetPolynomy } from '../../../../common/ObjectStructures/sKPI';
import { __onRenderMonthContent, CalendarCustomInput } from '../../../../common/CommonFuctions';
import PropTypes from 'prop-types';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import './style.css'
import 'react-datepicker/dist/react-datepicker.css';
import { useGetPolynomyBaseValues } from '../../../../hooks/component/sPay/useOfContractParties';
import { getPolinomioValorBase } from '../../../../services/sPay/partie.service';
import { Icon } from '@fluentui/react';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
const SidePanelBaseDateContractPartie = (props) => {
    
    const inputParam_IsDialogOpen = props.inputParam_IsDialogOpen !== null && props.inputParam_IsDialogOpen !== undefined ? props.inputParam_IsDialogOpen : false;
    const inputParam_SetIsDialogOpen = props.inputParam_SetIsDialogOpen !== null && props.inputParam_SetIsDialogOpen !== undefined ? props.inputParam_SetIsDialogOpen : null;
    const inputParam_SetSelectedBaseValue = props.inputParam_SetSelectedBaseValue !== null && props.inputParam_SetSelectedBaseValue !== undefined ? props.inputParam_SetSelectedBaseValue : null;
    const inputParam_NemoIndicator = props.inputParam_NemoIndicator !== null && props.inputParam_NemoIndicator !== undefined ? props.inputParam_NemoIndicator : null;
    const inputParam_StartDate = props.inputParam_StartDate !== null && props.inputParam_StartDate !== undefined ? props.inputParam_StartDate : null;
    
    const { t } = useTranslation();

    const gridRef = useRef();

    const [listBaseValues, setListBaseValues] = useState(null);
    const [selectedBaseDateValue, setSelectedBaseDateValue] = useState(null);
    const [queryBaseDateValue, setQueryBaseDateValue] = useState(inputParam_StartDate);

    useGetPolynomyBaseValues(inputParam_NemoIndicator, queryBaseDateValue, listBaseValues, setListBaseValues)

    const onDismissPanel = () => {
        inputParam_SetIsDialogOpen && inputParam_SetIsDialogOpen(false);
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const handleOnSelectBaseValue = () => {
        inputParam_SetSelectedBaseValue && inputParam_SetSelectedBaseValue({fecha: moment(selectedBaseDateValue.fecha).format('DD/MM/YYYY'), valor: selectedBaseDateValue.valor})
    };

    const handleRowSelect = (item) => {
        setSelectedBaseDateValue(item);
    };

    const handleDateChange = async (value) => {
        let isInValidValue = isNullUndefinedOrEmpty(value) || value === "0000/00";
        if (!isInValidValue) {
            const selectedBaseDate = moment(value).format('YYYY/MM');
            setQueryBaseDateValue(selectedBaseDate)

            try {
                let serviceResponse = await getPolinomioValorBase(inputParam_NemoIndicator, selectedBaseDate);
    
                if (serviceResponse.data.succeeded) {
                    const response = serviceResponse.data.data;
                    setListBaseValues(response)
                }
                else {
                    setListBaseValues([])
                } 
            } catch (error) {
                setListBaseValues([])
            }
        }
        else {
            //Desplegar mensaje que indique que debe seleccionar una fecha/valor de la grilla.
        }
    }

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        {
                            selectedBaseDateValue &&
                            <PrimaryButton onClick={handleOnSelectBaseValue} text={t('data-lang-btn-selectbasedate')} styles={_global_buttonStyles}/>
                        }
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const columns = [
        { index: null, text: 'ID',                        dataField: 'id',     uploadMasive: false, exportable: false, width: '0%',  columntype: 'textbox', editable: false, hidden: true },
        { index: 0,    text: t('data-lang-lbl-date'),     dataField: 'fecha',  uploadMasive: false, exportable: false, width: '25%', columntype: 'textbox', editable: false },
        { index: 1,    text: t('data-lang-lbl-value'),    dataField: 'valor',  uploadMasive: false, exportable: false, width: '50%', columntype: 'textbox', editable: false },
        { index: 2,    text: t('data-lang-lbl-currency'), dataField: 'moneda', uploadMasive: false, exportable: false, width: '25%', columntype: 'textbox', editable: false },
    ]

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsDialogOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-selectbasedate') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                type={PanelType.custom}
                customWidth="950px"
            >
                <div>
                    <div className='pt-4'>
                        <Row className='pt-1'>
                            <Col style={{zIndex: 999999}}>
                                <CLabel labelText={ t('data-lang-lbl-date') } /><br/>
                                <DatePicker
                                    selected={ queryBaseDateValue && moment(queryBaseDateValue, "YYYY/MM").toDate() } 
                                    onChange={handleDateChange}
                                    height={25}
                                    dateFormat="yyyy/MM"
                                    maxDate={moment(new Date(), "YYYY/MM").toDate()} 
                                    showMonthYearPicker
                                    showFullMonthYearPicker
                                    renderMonthContent={__onRenderMonthContent}
                                    placeholderText={ t('data-lang-lbl-date') } 
                                    className="form-control"
                                    customInput={ <CalendarCustomInput icon={<Icon iconName='Calendar' style={{cursor: "pointer"}} />} /> }
                                />
                            </Col>
                        </Row>
                        <Row className='pt-1'>
                            <Col className="mt-3">
                                <div>{t('data-lang-lbl-contractpartie-basevalues')}</div>
                                <div className="custom-table-container">
                                    <table className="custom-table">
                                        <thead>
                                            <tr>
                                                <th>{t('data-lang-lbl-date')}</th>
                                                <th>{t('data-lang-lbl-value')}</th>
                                                <th>{t('data-lang-lbl-currency')}</th>
                                            </tr>
                                        </thead>
                                        <tbody className='w-100 h-100'>
                                            {
                                                listBaseValues && listBaseValues.map((item, index) => (
                                                    <tr key={item.id} onClick={() => handleRowSelect(item)} style={{cursor: "pointer", backgroundColor: selectedBaseDateValue && selectedBaseDateValue.id === item.id ? "#ececec" : ""}}>
                                                        <td>{moment(item.fecha).format("DD/MM/YYYY")}</td>
                                                        <td>{item.valor}</td>
                                                        <td>{item.moneda}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </Panel>
        </div>
    );
};

SidePanelBaseDateContractPartie.propTypes = {
    elementId: PropTypes.number.isRequired,
};

export default SidePanelBaseDateContractPartie;